import * as THREE from 'three'
import {
  ThreeExt
} from '@/drawings3D/CoordUtils.js';

import {Text} from '@/drawings3D/models/Text'
import {Defect} from '@/drawings3D/models/Defect'
import {GroundTextLoader} from '@/drawings3D/modelDrawing/DirectModel/GroundTextLoader'
import {ArrowLoader} from '@/drawings3D/modelDrawing/DirectModel/ArrowLoader'
import {GroundDefectLoader} from '@/drawings3D/modelDrawing/DirectModel/GroundDefectLoader'
import {BannerLoader} from '@/drawings3D/modelDrawing/DirectModel/BannerLoader'

export var DefectControlCommand = function(defectControlCmd, defectPanel,defecttype,info) {
	this.defectControlCmd = defectControlCmd;
	this.defectPanel = defectPanel;
	this.defecttype=defecttype;
	this.info=info;
}
DefectControlCommand.prototype = {
	constructor: DefectControlCommand,
	exec: function(scope) {
		if (this.defectControlCmd === 0) {
			//init a model
			var modelInfo = {
				modelPath: '/static/bimroad/3DModels/light/',
				name: 'light01'
			}

			scope.sceneManager.loadModel(modelInfo);
		}
		else if (this.defectControlCmd === 1){
			var text = new Text({
				color:0xffffff,
				text: '60',
				size:1.5,
				height:0.1
			});
			var groundTextLoader = new GroundTextLoader(text,scope.sceneManager);
			scope.sceneManager.loadDirectModelFromLoader({name:'groundText1'}, groundTextLoader);
		}
		else if (this.defectControlCmd === 2){
			var defect = new Defect({
				defecttype:this.defecttype,
				severity: 'H',
				defectLength:3,
				defectWidth:3,
				defectDepth:1,
				area :0.1,
				laneNo:1
			});
			var defectLoader = new GroundDefectLoader(defect,scope.sceneManager,this.info);
			scope.sceneManager.loadDirectModelFromLoader({name:'groundDefect1',info:this.info}, defectLoader);
		}
		else if (this.defectControlCmd === 3){
			var arrow = {
				shapeType:3,
				color:0xffffff
			};
			var arrowLoader = new ArrowLoader(arrow,scope.sceneManager);
			scope.sceneManager.loadDirectModelFromLoader({name:'arrow1'}, arrowLoader);
		}
		else if (this.defectControlCmd === 4){
			//init a model
			var modelInfo = {
				modelPath: '/static/bimroad/3DModels/roadIndicator/',
				name: 'bzp',
				extraPartConfig:{
					bannerStyle:{
						color:"#ffffff",
						// backgroundColor: "#103ba4",
						backgroundColor: "#108248",
						bannerWidth:4,
						bannerHeight:2.5,
						boundingWidth:300,
						boundingHeight:150,
						//针对不同样式的路牌，定制不同的json模板
						shape:{
							type:1,
							width:300,
							height:150,
							template:[{
								index:1,
								type: 'hor-separator',
								color:'#ffffff',	
								pos: 0.33	
							},
							{
								index:2,
								type: 'hor-separator',
								color:'#ffffff',	
								pos: 0.66	
							},
							{
								index:3,
								type: 'text',
								color:'#ffffff',
								size:30,
								pos:{x: 0.1, y:0.06},	
							},
							{
								index:4,
								type: 'text',
								color:'#ffffff',
								size:30,
								pos:{x: 0.1, y:0.38},	
							},
							{
								index:5,
								type: 'text',
								color:'#ffffff',
								size:30,
								pos:{x: 0.1, y:0.70},	
							}
							]
						}
					},
					//这部分是具体公告牌数据
					contentArray:(this.info.data||[{index:3, text:'武汉         23km'},
					{index:4, text:'长沙        440km'},
					{index:5, text:'广州        820km'},]),
					option:{
						option:{
							info:{
								type:'roadSign',
								largeClass:'roadSign',
								rightClick:true
							}
						}
					}
					
				}
			}
			var modelLoader = new BannerLoader(modelInfo, scope.sceneManager);

			scope.sceneManager.loadModel(modelInfo, modelLoader);
		}
		else if (this.defectControlCmd === 5){
			scope.$refs.navControlPanel.showSelf = true;
		}

	} 
}


// WEBPACK FOOTER //
// ./src/plugins/components/Web3dModels/commands/DefectControlCommand.js